"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _pick2 = _interopRequireDefault(require("lodash/pick"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FETCH_OPTIONS = ['method', 'headers', 'body', 'mode', 'credentials', 'cache', 'redirect', 'referrer', 'referrerPolicy', 'integrity', 'keepalive', 'signal']; // Extracts all fetch options into a single object in preparation for passing to Fetch().
// This should be the last middleware applied.

function extractFetchOptions(config) {
  return {
    fetchOptions: (0, _pick2["default"])(config, FETCH_OPTIONS)
  };
}

var _default = extractFetchOptions;
exports["default"] = _default;